// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb_config[data-v-b8030be4]{position:relative}.navIcon[data-v-b8030be4]{height:150px;font-size:.95rem;line-height:1.3}.navIcon[data-v-b8030be4],.navIconGestorConfig[data-v-b8030be4]{width:125px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
